import { Link, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/context/AuthContext";
import LanguageSwitch from "@/components/LanguageSwitch";
import { LayoutGrid, Plus, History as HistoryIcon, LogOut, BrainCircuit } from "lucide-react";

export default function Navbar() {
  const { t } = useTranslation();
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const links = [
    { to: "/dashboard", label: t("nav.dashboard"), icon: LayoutGrid, id: "nav-dashboard" },
    { to: "/new", label: t("nav.new"), icon: Plus, id: "nav-new" },
    { to: "/history", label: t("nav.history"), icon: HistoryIcon, id: "nav-history" },
  ];

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-[#0B0E14]/80 border-b border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between gap-4">
        <Link to={user ? "/dashboard" : "/"} className="flex items-center gap-2.5 group" data-testid="navbar-brand">
          <div className="h-9 w-9 rounded-lg bg-primary/15 border border-primary/40 flex items-center justify-center shadow-[0_0_15px_rgba(124,58,237,0.25)]">
            <BrainCircuit className="h-5 w-5 text-primary" />
          </div>
          <div className="leading-tight">
            <div className="font-heading font-bold text-foreground">{t("brand")}</div>
            <div className="text-[10px] tracking-[0.18em] uppercase text-muted-foreground">{t("tagline")}</div>
          </div>
        </Link>

        {user && (
          <nav className="hidden md:flex items-center gap-1">
            {links.map((l) => {
              const active = location.pathname === l.to;
              const Icon = l.icon;
              return (
                <Link key={l.to} to={l.to} data-testid={l.id}
                  className={`flex items-center gap-2 px-3.5 py-2 rounded-lg text-sm transition-all ${active ? "bg-primary/15 text-foreground border border-primary/30" : "text-muted-foreground hover:text-foreground hover:bg-secondary/60"}`}>
                  <Icon className="h-4 w-4" /> {l.label}
                </Link>
              );
            })}
          </nav>
        )}

        <div className="flex items-center gap-3">
          <LanguageSwitch />
          {user && (
            <div className="flex items-center gap-3">
              {user.picture && <img src={user.picture} alt="" className="h-8 w-8 rounded-full border border-border" />}
              <button onClick={logout} data-testid="logout-btn"
                className="flex items-center gap-1.5 text-sm text-muted-foreground hover:text-destructive transition-colors">
                <LogOut className="h-4 w-4" /> <span className="hidden sm:inline">{t("nav.logout")}</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
